<template>
  <div>
    <QCard class="my-card">
      <QCardSection class="bg-primary text-white">
        <div class="text-h6">Plugins</div>
      </QCardSection>
      <QSeparator dark />
      <QCardSection>Installed plugins to run this porject</QCardSection>
      <QSeparator dark />
      <QCardActions class="bg-primary text-white">
        <QBtnGroup>
          <QBtn
            type="a"
            target="_blank"
            href="https://github.com/vuejs/vue-cli/tree/dev/packages/%40vue/cli-plugin-babel"
            color="secondary"
          >Babel</QBtn>
          <QBtn
            type="a"
            target="_blank"
            href="https://github.com/vuejs/vue-cli/tree/dev/packages/%40vue/cli-plugin-eslint"
            color="secondary"
          >ESLint</QBtn>
        </QBtnGroup>
      </QCardActions>
    </QCard>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import {
  QPage,
  QCard,
  QCardSection,
  QCardActions,
  QBtnGroup,
  QBtn,
  QSeparator,
  QIcon
} from "quasar";

@Component({
  components: {
    QPage,
    QCard,
    QCardSection,
    QCardActions,
    QBtn,
    QBtnGroup,
    QSeparator,
    QIcon
  }
})
export default class VueCli extends Vue {}
</script>

<style lang="sass" scoped>
.my-card
    display: inline-block
    margin: 0.5em
</style>
